import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Team = () => {
  const { t } = useTranslation();

  // Dummy-Daten für Teammitglieder, jetzt mit dynamisch geladenen Rollen
  const teamMembers = [
    { name: 'Salokhiddin Tursunov', role: t('team.roles.founder'), photo: '/images/Salo.JPG' },
    { name: 'Shokhrukh Maxmudov', role: t('team.roles.mainteacher'), photo: '/images/Shokhrukh Maxmudov Hauptslehrer.jpeg', pos: '50% 32%' },
    { name: 'Abdullokh Tolipov', role: t('team.roles.teacher'), photo: '/images/Abdullokh Tolipov Lehrkraft.JPG' },
    { name: 'Iroda Choriyeva', role: t('team.roles.supportteacher'), photo: '/images/Iroda Choriyeva Förderlehrerin.jpeg' },
    { name: 'Laylo Olimova', role: t('team.roles.supportteacher'), photo: '/images/Laylo Olimova Förderlehrerin.jpg' },
    { name: 'Tim Schäfer', role: t('team.roles.cofounder'), photo: '/images/Tim.jpeg' },
  ];

  const { ref: rowRef, inView: rowInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div id="team" className="py-16 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 first-letter:uppercase">{t('team.title')}</h2>
          <div className="mt-3 mx-auto h-1 w-16 rounded-full bg-violet-600" />
        </div>
        <div
          className={`grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-10 max-w-4xl mx-auto ${rowInView ? 'animate-fade-in' : ''}`}
          ref={rowRef}
        >
          {teamMembers.map((member, index) => (
            <TeamMember key={index} member={member} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

const TeamMember = ({ member, index }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
    delay: index * 200, // Verlangsamt die Animation für jede Kachel individuell
  });


  return (
    <motion.div
      ref={ref}
      className="group flex flex-col items-center text-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 20 }}
      transition={{ duration: 0.6 }}
    >
      <div className="relative w-40 h-40 sm:w-44 sm:h-44 rounded-full overflow-hidden ring-4 ring-white shadow-lg bg-gray-100">
        <img
          src={member.photo}
          alt={member.name}
          loading="lazy"
          style={{ objectPosition: member.pos || 'center top' }}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
      </div>
      <h3 className="mt-4 text-base sm:text-lg font-semibold text-gray-900">{member.name}</h3>
      <p className="mt-0.5 text-sm font-medium text-violet-600">{member.role}</p>
    </motion.div>
  );
};

export default Team;
